<template>
    <div class="home-container">
        <!-- 手机端遮罩层：点击关闭侧边栏 -->
        <div
                class="sj-mobile-overlay"
                v-if="isMobile && isSidebarOpen"
                @click="closeSidebar"
        ></div>

        <!-- 左侧菜单 -->
        <aside
                class="home-sidebar"
                :class="{
                    'home-collapsed': isCollapsed,
                    'sj-mobile-sidebar': isMobile,
                    'sj-sidebar-open': isMobile && isSidebarOpen
                }"
        >
            <!-- 侧边栏头部 - 用户信息 -->
            <div class="home-sidebar-header">
                <div
                        class="home-user-avatar-wrapper"
                        @click.stop="toggleAvatarMenu"
                        ref="avatarRef"
                >
                    <img
                            :src="userInfo.avatar"
                            alt="用户头像"
                            class="home-user-avatar"
                    >
                    <!-- 用户头像下拉菜单 -->
                    <div
                            class="home-avatar-dropdown"
                            :class="{ 'home-show': isAvatarMenuShow, 'home-left-aligned': isCollapsed }"
                            @mouseleave="handleAvatarMenuLeave"
                            :style="avatarDropdownStyle"
                    >
                        <div
                                class="home-dropdown-item"
                                @click="handleShowUserInfo"
                        >
                            <i class="fa fa-user"></i>
                            <span>我的信息</span>
                        </div>
                        <div
                                class="home-dropdown-item"
                                @click="handleLogout"
                        >
                            <i class="fa fa-sign-out"></i>
                            <span>退出登录</span>
                        </div>
                    </div>
                </div>

                <div class="home-user-info" :class="{ 'home-hidden': isCollapsed }">
                    <div class="home-user-name">{{ userInfo.username }}</div>
                    <div class="home-user-role-wrapper" @click.stop="toggleRoleMenu">
            <span class="home-user-role">
              {{ currentRole.roleName }}
              <i class="fa fa-chevron-down home-role-arrow" v-if="userInfo.roles && userInfo.roles.length > 1"></i>
            </span>
                        <!-- 角色下拉菜单 -->
                        <div
                                class="home-role-dropdown"
                                :class="{ 'home-show': isRoleMenuShow }"
                                @mouseleave="closeRoleMenu"
                        >
                            <div
                                    class="home-role-item"
                                    v-for="role in userInfo.roles"
                                    :key="role.roleId"
                                    @click="changeRole(role)"
                                    :class="{ 'home-active': currentRole.roleId === role.roleId }"
                            >
                                {{ role.roleName }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 菜单收缩按钮（仅网页端显示） -->
                <div class="home-collapse-btn sj-desktop-only" @click.stop="toggleCollapse">
                    {{ isCollapsed ? '&gt;&gt;' : '&lt;&lt;' }}
                </div>

                <!-- 手机端关闭侧边栏按钮 -->
                <div class="sj-mobile-close-btn sj-mobile-only" @click.stop="closeSidebar">
                    &times;
                </div>
            </div>

            <!-- 递归菜单列表：替换原有三级循环为Element Plus树组件
             :default-expand-all="false" 默认是否展开
             :expand-on-click-node="true" 开关点击节点是否打开下拉框
            -->
            <div class="home-menu-container" v-if="!isCollapsed || isMobile">
                <el-tree
                        ref="menuTreeRef"
                        :data="sortedMenuList"
                        :props="treeProps"
                        :default-expand-all="false"
                        :expand-on-click-node="true"
                        @node-click="handleTreeMenuClickMobile"
                        class="home-menu-tree"
                >
                    <!-- 自定义树节点内容：保留原有图标逻辑 -->
                    <template #default="{ data , node  }">
                        <div class="home-main-menu" :class="{ 'home-active': activeMenuUrl === data.menuUrl }">
                            <span class="menu-icon">
                                <!-- 1. URL图标：直接显示图片 -->
                                <img v-if="data.menuIcon?.includes('http')" :src="data.menuIcon" alt="图标" class="home-menu-icon-img">
                                <!-- 2. 非URL：渲染Element图标组件 -->
                                <el-icon v-else-if="data.menuIcon" :class="data.menuIcon">
                                    <component :is="data.menuIcon"/>
                                </el-icon>
                            </span>
                            <span class="home-menu-text">{{ node.label }}</span>
                        </div>
                    </template>
                </el-tree>
            </div>
        </aside>

        <!-- 主内容区域 -->
        <main class="home-main-content">
            <!-- 手机端顶部导航栏 -->
            <div class="sj-mobile-topbar sj-mobile-only">
                <!-- 汉堡菜单按钮 -->
                <div class="sj-hamburger-btn" @click="openSidebar">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <!-- 页面标题（面包屑） -->
                <h2 class="sj-mobile-title">{{ currentPageTitle }}</h2>
            </div>

            <!-- 网页端内容头部 -->
            <div class="home-content-header sj-desktop-only">
                <h2 class="home-welcome-text">
                    {{ currentPageTitle }}
                </h2>
                <div class="home-current-time">{{ currentTime }}</div>
            </div>

            <!-- 路由视图出口 - 用于显示各页面内容 -->
            <router-view class="home-content-card"></router-view>
            <!-- 备案号 -->
            <div class="icp-footer">
                <a href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备2026022872号-2</a>
            </div>
        </main>

        <!-- 我的信息弹窗 -->
        <el-dialog v-model="showUserInfoDialog" title="我的信息" width="700px">
            <el-descriptions :column="1" border>
                <el-descriptions-item label="用户名">{{ userDetail.userName }}</el-descriptions-item>
                <el-descriptions-item label="用户角色">{{ userDetail.roleNames }}</el-descriptions-item>
                <el-descriptions-item label="手机号">{{ userDetail.phoneNumber }}</el-descriptions-item>
                <el-descriptions-item label="邮箱">{{ userDetail.email }}</el-descriptions-item>
                <el-descriptions-item label="微信">{{ userDetail.wechat }}</el-descriptions-item>
            </el-descriptions>

            <!-- 公司信息 -->
            <div style="margin-top: 20px;">
                <div style="margin-bottom: 10px;">
                    <span style="font-weight: bold;">公司信息</span>
                </div>
                <el-table v-if="userDetail.companyList && userDetail.companyList.length" :data="userDetail.companyList" border style="width: 100%;">
                    <el-table-column prop="companyName" label="公司名称" width="180"></el-table-column>
                    <el-table-column prop="companyType" label="公司类型" width="120">
                        <template #default="{ row }">
                            {{ getCompanyTypeName(row.companyType) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="contactPhone" label="联系电话" width="130"></el-table-column>
                    <el-table-column prop="companyAddress" label="公司地址"></el-table-column>
                    <el-table-column prop="miniProgramCode" label="小程序编码" width="250" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="isMain" label="主公司" width="80">
                        <template #default="{ row }">
                            <el-tag v-if="row.isMain === '1'" type="success">是</el-tag>
                            <el-tag v-else type="info">否</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-else style="color: #909399;">暂无公司信息</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {ref, onMounted, onUnmounted} from 'vue';
    import {useRoute, useRouter} from 'vue-router';
    import {
        changeRole,
        cleanPageResources,
        handleTreeMenuClick,
        initPageData,
        logout,
        sortMenus,
        loadUserDetail,
        getCompanyTypeName as getCompanyTypeNameUtil
    } from './home.js';

    export default {
        name: 'HomePage',
        setup() {
            const router = useRouter();
            const route = useRoute();
            const avatarRef = ref(null);
            const menuTreeRef = ref(null); // 菜单树实例
            // 手机端相关响应式变量
            const isMobile = ref(false);
            const isSidebarOpen = ref(false);
            let resizeTimer = null;

            // 检测是否为手机端
            const checkMobile = () => {
                isMobile.value = window.innerWidth <= 768;
                // 手机端默认关闭侧边栏
                if (isMobile.value) {
                    isSidebarOpen.value = false;
                }
            };

            // 窗口大小变化监听
            const handleResize = () => {
                if (resizeTimer) clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    checkMobile();
                }, 100);
            };

            onMounted(() => {
                checkMobile();
                window.addEventListener('resize', handleResize);
            });

            onUnmounted(() => {
                window.removeEventListener('resize', handleResize);
                if (resizeTimer) clearTimeout(resizeTimer);
            });

            return {
                router,
                route,
                avatarRef,
                menuTreeRef,
                isMobile,
                isSidebarOpen
            };
        },
        data() {
            return {
                // 菜单状态
                menuList: [],
                isCollapsed: false,
                activeMenuUrl: this.$route?.path || '/home',
                // 树组件配置
                treeProps: {
                    key: 'menuId',       // 节点唯一标识
                    label: 'menuName',   // 节点显示文本
                    children: 'children',// 子节点字段
                    sort: 'sortNum'      // 排序字段
                },

                // 用户信息
                userInfo: {
                    userId: '',
                    username: '',
                    roles: [],
                    avatar: ''
                },
                currentRole: {},  // 当前选中的角色

                // 头像菜单状态
                isAvatarMenuShow: false,
                avatarTimer: null,

                // 角色菜单状态
                isRoleMenuShow: false,

                // 时间相关
                currentTime: '',

                // 当前页面标题
                currentPageTitle: '首页',

                // 定时器/监听器缓存
                timeInterval: null,
                routeListener: null,

                // 我的信息弹窗
                showUserInfoDialog: false,
                userDetail: {
                    userName: '',
                    roleNames: '',
                    phoneNumber: '',
                    wechat: '',
                    companyList: []
                },
                // 公司类型枚举
                companyTypeList: []
            };
        },
        computed: {
            // 排序后的菜单列表（首页置顶，其余按sortNum升序）
            sortedMenuList() {
                return sortMenus(this.menuList);
            },
            // 动态计算头像下拉菜单位置，确保不超出屏幕
            avatarDropdownStyle() {
                if (!this.isAvatarMenuShow) return {};

                // 获取头像元素位置信息
                const avatarRect = this.avatarRef?.value?.getBoundingClientRect();
                if (!avatarRect) return {};

                // 计算下拉菜单应该显示的位置
                const dropdownWidth = 200;

                // 收起状态下的位置计算
                if (this.isCollapsed) {
                    // 确保下拉菜单不会超出右侧屏幕
                    const leftPos = Math.min(avatarRect.left, window.innerWidth - dropdownWidth - 10);
                    return {left: `${leftPos}px`, right: 'auto'};
                } else {
                    // 展开状态下的位置计算
                    const rightPos = window.innerWidth - avatarRect.right;
                    // 确保下拉菜单不会超出左侧屏幕
                    const maxRight = window.innerWidth - dropdownWidth - 10;
                    return {right: `${Math.min(rightPos, maxRight)}px`, left: 'auto'};
                }
            }
        },
        methods: {
            // 代理到home.js的方法
            handleTreeMenuClick(data) {
                // 显式传递组件实例（this）作为 context
                handleTreeMenuClick(this, data);
            },
            // 手机端菜单点击：menuType != 2 时不收缩侧边栏
            handleTreeMenuClickMobile(data) {
                handleTreeMenuClick(this, data);
                // 手机端点击菜单后，只有menuType == 2（菜单项）时才关闭侧边栏
                if (this.isMobile && data.menuType == '2') {
                    this.closeSidebar();
                }
            },
            async changeRole(role) {
                // 这里的 this 是组件实例，作为 context 传递给 home.js 的 changeRole
                await changeRole(this, role);
            },
            async handleShowUserInfo() {
                this.isAvatarMenuShow = false;
                await loadUserDetail(this);
                this.showUserInfoDialog = true;
            },
            getCompanyTypeName(code) {
                return getCompanyTypeNameUtil(this, code);
            },
            handleLogout() {
                logout();
                this.isAvatarMenuShow = false;
            },

            // 菜单收缩切换
            toggleCollapse() {
                this.isCollapsed = !this.isCollapsed;
            },

            // 头像菜单切换
            toggleAvatarMenu() {
                this.isAvatarMenuShow = !this.isAvatarMenuShow;
            },

            // 头像菜单鼠标离开
            handleAvatarMenuLeave() {
                this.avatarTimer = setTimeout(() => {
                    this.isAvatarMenuShow = false;
                }, 300);
            },

            // 角色菜单切换
            toggleRoleMenu() {
                // 只有多个角色时才显示切换菜单
                if (this.userInfo.roles && this.userInfo.roles.length > 1) {
                    this.isRoleMenuShow = !this.isRoleMenuShow;
                }
            },

            // 关闭角色菜单
            closeRoleMenu() {
                setTimeout(() => {
                    this.isRoleMenuShow = false;
                }, 300);
            },

            // ========== 手机端方法 ==========
            // 打开侧边栏
            openSidebar() {
                this.isSidebarOpen = true;
                // 手机端侧边栏始终展开
                this.isCollapsed = false;
            },
            // 关闭侧边栏
            closeSidebar() {
                this.isSidebarOpen = false;
            }
        },
        mounted() {
            // 初始化页面核心数据
            initPageData(this);
        },
        beforeUnmount() {
            // 清理页面资源
            cleanPageResources(this);
        }
    };
</script>

<style scoped>
    @import '../../assets/css/home.css';
</style>
